

// Add XDebug value to local URLs
export const UseUrlManagerCleanUrl = ({ url }) => {
    if (typeof url == 'undefined') {
        return url;
    }
    if (window.location.href.includes('local')) {

        if (url.includes('?')) {
            url += '&XDEBUG_SESSION_START=PHPSTORM';
        } else {
            url += '?XDEBUG_SESSION_START=PHPSTORM';
        }

    }

    return url;
}

export const hostUrl: string = import.meta.env.VITE_HOST_URL;
export const frontUrl: string = import.meta.env.VITE_FRONT_URL;
export const apiUrl: string = import.meta.env.VITE_API_URL;
export const adminURL: string = import.meta.env.VITE_HQ_URL;

